// extracted by mini-css-extract-plugin
module.exports = {"base":"iwEJIe","leftColumn":"_2xolnk","rightColumn":"_1rRmbO"};